module.exports = __webpack_public_path__ + "static/img/曲线 2.ac0c96f6.png";